import { delay } from 'q'
import consumers from './fakes/consumers'
import { Consumer, ConsumersServiceInterface, SingleResponse, ValidateConsumerUploadResponse } from '../types'
import { createFakeSingleResponse } from './fakes/createFakeResponse'

export default class MockConsumerService implements ConsumersServiceInterface {
	public async validate(): Promise<ValidateConsumerUploadResponse> {
		throw new Error('Method not implemented.')
	}

	public async upload(): Promise<void> {
		throw new Error('Method not implemented.')
	}

	public async get(): Promise<SingleResponse<Consumer[]>> {
		await delay(500)
		return createFakeSingleResponse(consumers)
	}

	public async add(customerId: number, serial: string, username: string): Promise<SingleResponse<Consumer>> {
		await delay(500)
		consumers.push({ username })
		return createFakeSingleResponse({ username })
	}

	public async remove(customerId: number, serial: string, username: string): Promise<void> {
		await delay(500)
		const index = consumers.findIndex(elem => elem.username === username)
		consumers.splice(index, 1)
	}
}
